import { postJson } from 'utils/fetch';

export const getCustomersWithoutContact = invoices =>
  postJson('/pco-manager/invoices/customers.json', JSON.stringify(invoices));



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/emit/api.js